// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"c7d48311","500":"99b8e4c2"}[chunkId] + ".chunk.css";
};